import { InfoAdapterType } from "features/shared/types/info";
import { emptySubProductTable } from "../constants/templates";
import { Product } from "../types/product";

export const unflattenProduct = (
    flattenedProduct: Record<string, any>
): Product => {
    let unflattenedProduct: Product = {
        id: flattenedProduct.id,
        tags: flattenedProduct.tags ? flattenedProduct.tags.split(",") : [],
        tables: flattenedProduct.tables
            ? JSON.parse(flattenedProduct.tables)
            : { [Date.now().toString()]: { ...emptySubProductTable } },
        tableIds: flattenedProduct.tableIds
            ? flattenedProduct.tableIds.split(",")
            : [],
        properties: {
            type: InfoAdapterType.DefaultInfo, // product only uses this
        },
    };

    if (flattenedProduct.name_en || flattenedProduct.name_th) {
        unflattenedProduct.properties.name = {
            en: flattenedProduct.name_en || "",
            th: flattenedProduct.name_th || "",
        };
    }
    if (flattenedProduct.description_en || flattenedProduct.description_th) {
        unflattenedProduct.properties.description = {
            en: flattenedProduct.description_en || "",
            th: flattenedProduct.description_th || "",
        };
    }

    if (flattenedProduct.qtyUnit_en || flattenedProduct.qtyUnit_th) {
        unflattenedProduct.properties.qtyUnit = {
            en: flattenedProduct.qtyUnit_en || "",
            th: flattenedProduct.qtyUnit_th || "",
        };
    }

    flattenedProduct.image &&
        (unflattenedProduct.properties.image = flattenedProduct.image);
    flattenedProduct.seo &&
        (unflattenedProduct.properties.seo = flattenedProduct.seo);
    flattenedProduct.rank &&
        (unflattenedProduct.properties.rank = flattenedProduct.rank);
    flattenedProduct.categoryRank &&
        (unflattenedProduct.properties.categoryRank =
            flattenedProduct.categoryRank);
    flattenedProduct.viewCount &&
        (unflattenedProduct.properties.viewCount = flattenedProduct.viewCount);

    return unflattenedProduct;
};

export const flattenProduct = (product: Product) => {
    return {
        id: product.id,
        name_en: product.properties.name?.en,
        name_th: product.properties.name?.th,
        description_en: product.properties.description?.en,
        description_th: product.properties.description?.th,
        qtyUnit_en: product.properties.qtyUnit?.en,
        qtyUnit_th: product.properties.qtyUnit?.th,
        image: product.properties.image,
        seo: product.properties.seo,
        rank: product.properties.rank,
        categoryRank: product.properties.categoryRank,
        viewCount: product.properties.viewCount,
        tags: product.tags.join(","),
        tables: JSON.stringify(product.tables),
        tableIds: product.tableIds.join(","),
    };
};
